import { Box } from "@connected-repo/ui-mui/layout/Box";
import { OfflineBanner } from "@frontend/components/layout/OfflineBanner";
import { TopProgressBar } from "@frontend/components/layout/TopProgressBar";
import { PwaUpdatePrompt } from "@frontend/components/pwa/update_prompt.pwa";
import { Outlet } from "react-router";

export const RootLayout = () => {
	return (
		<>
			<TopProgressBar />
			<OfflineBanner />
			{/* Pushes every screen below the offline bar (0px when online). */}
			<Box aria-hidden sx={{ height: "var(--offline-bar, 0px)" }} />
			<Outlet />
			<PwaUpdatePrompt />
		</>
	);
};
